import React, { useCallback, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function PricingSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const handleAddToCart = useCallback(() => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Emprender con hijos sin perder la cabeza - Ebook',
        content_type: 'product',
        value: 9499.0,
        currency: 'ARS'
      });
    }
  }, []);
  return <section ref={ref} id="precio" className="w-full bg-[#FDF8F3] py-20 md:py-28" data-id="element-140">
      <div className="max-w-4xl mx-auto px-6" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center mb-12" data-id="element-142">
          <div className="inline-flex items-center gap-2 bg-[#E07A5F] text-white text-sm font-semibold px-4 py-2 rounded-full mb-6" data-id="element-143">
            <SparklesIcon className="w-4 h-4" data-id="element-144" />
            <span data-id="element-145">OFERTA POR TIEMPO LIMITADO</span>
          </div>

          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D] leading-tight" data-id="element-146">
            Tu tiempo es tu activo más valioso.
          </h2>
          <p className="font-['Playfair_Display'] text-2xl md:text-3xl text-[#B794C0] mt-2" data-id="element-147">
            No dejes que el caos te lo siga quitando.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border-2 border-[#B794C0]" data-id="element-148">
          <p className="text-lg text-[#4A4A4A] text-center mb-8 leading-relaxed" data-id="element-149">
            Invertir en tu sistema de trabajo es la decisión más rentable que
            puedes tomar este mes como emprendedora. Por lanzamiento limitado,
            accede al Ebook Completo (PDF) con un beneficio exclusivo:
          </p>

          <div className="text-center mb-8" data-id="element-150">
            <p className="text-[#4A4A4A] mb-2" data-id="element-151">Valor de Mercado:</p>
            <p className="text-2xl text-[#4A4A4A] line-through" data-id="element-152">
              $18.998 + IVA
            </p>

            <div className="mt-6 mb-2" data-id="element-153">
              <span className="inline-block bg-[#E07A5F] text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-154">
                50% OFF
              </span>
            </div>

            <p className="text-sm text-[#B794C0] font-medium mb-2" data-id="element-155">
              Preventa Exclusiva:
            </p>
            <p className="font-['Playfair_Display'] text-5xl md:text-6xl font-bold text-[#2D2D2D]" data-id="element-156">
              $9.499<span className="text-2xl" data-id="element-157">,00</span>
            </p>
            <p className="text-[#4A4A4A] mt-1" data-id="element-158">+ IVA*</p>
          </div>

          <p className="text-center text-[#4A4A4A] text-sm mb-8" data-id="element-159">
            (Pago único. Acceso inmediato a tu correo tras la confirmación).
          </p>

          <div className="flex justify-center" data-id="element-160">
            <motion.a href="https://mujerequilibrista.com/cart/48477736337637:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-[#E07A5F] text-white font-bold text-lg md:text-xl px-10 py-5 rounded-full shadow-lg shadow-[#E07A5F]/30 transition-colors hover:bg-[#C96A52] text-center" data-id="element-161">
              ¡QUIERO MI COPIA AL 50% DE DESCUENTO!
            </motion.a>
          </div>

          <p className="text-center text-[#4A4A4A] text-xs mt-8 leading-relaxed" data-id="element-162">
            (*) Importante: El valor final puede variar según la condición
            fiscal y los impuestos locales aplicables al momento de la compra
            (IVA 21%).
          </p>
        </motion.div>
      </div>
    </section>;
}